class ProductContent extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setHeights = this.setHeights.bind(this)
    this.setHeights()

    this.resizeObserver = new ResizeObserver(this.setHeights);
    [
      this.els.content,
      this.els.style,
      this.els.tabs,
      this.els.description,
    ].forEach((el) => {
      if (el?.element) this.resizeObserver.observe(el.element)
    })
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.resizeObserver?.disconnect()
  }

  setHeights () {
    const contentHeight = this.els.content?.element.offsetHeight || 0
    const styleHeight = this.els.style?.element.offsetHeight || 0
    const tabsHeight = this.els.tabs?.element.offsetHeight || 0
    const descriptionHeight = this.els.description?.element.offsetHeight || 0

    this.style.setProperty('--Top', `${contentHeight}px`)
    this.style.setProperty('--Style_Height', `${styleHeight}px`)
    this.style.setProperty('--Tabs_Height', `${tabsHeight}px`)
    this.style.setProperty('--Description_Height', `${descriptionHeight}px`)
  }
}

if (!customElements.get('product-content')) {
  customElements.define('product-content', ProductContent)
}
